import {Component, OnInit} from '@angular/core';
import {BreadcrumbsService} from '../../shared/components/breadcrumbs/breadcrumbs.service';

@Component({
    selector: 'kkk-homegroups',
    templateUrl: './homegroups.component.html'
})
export class HomegroupsComponent implements OnInit {
    constructor(
        private _breadcrumbs: BreadcrumbsService,
    ) {
    }

    ngOnInit() {
        this._breadcrumbs
            .start({name: 'Mit teszünk?', instructions: ['/mit-teszunk']})
            .add({name: 'Programok', instructions: ['/programok']})
            .add({name: 'Házicsoportok'});
    }
}



// WEBPACK FOOTER //
// /Users/manuel/Development/kkk/frontend/src/app/what-we-do/homegroups/homegroups.component.ts